import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Offerings", href: "#offerings" },
  { label: "Music", href: "#music" },
  { label: "Events", href: "#events" },
  { label: "About", href: "#about" },
  { label: "Connect", href: "#contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-[#f7efe2]/90 backdrop-blur-md shadow-[0_1px_20px_rgba(156,85,96,0.12)]" : "bg-transparent"
      }`}
    >
      <nav className="max-w-6xl mx-auto px-6 h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => go("#top")}
          className="font-display text-2xl md:text-[26px] text-[#9c5560] tracking-wide leading-none text-left"
        >
          Rosefield<span className="text-[#c2a04b]"> Harmonic</span>
        </button>

        <div className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.label}
              data-testid={`nav-${l.label.toLowerCase()}`}
              onClick={() => go(l.href)}
              className="font-accent text-[15px] text-[#3a2630] hover:text-[#b76e79] transition-colors tracking-wide relative group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-[#b76e79] transition-all duration-300 group-hover:w-full" />
            </button>
          ))}
          <button
            data-testid="nav-get-in-touch"
            onClick={() => go("#contact")}
            className="font-accent text-sm tracking-wide px-5 py-2.5 rounded-full bg-[#b76e79] text-[#f7efe2] hover:bg-[#9c5560] transition-colors"
          >
            Get in Touch
          </button>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((o) => !o)}
          className="md:hidden text-[#9c5560] p-1"
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-[#f7efe2]/98 backdrop-blur-md border-t border-[#e3b4b0]/40 px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <button
              key={l.label}
              data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              onClick={() => go(l.href)}
              className="font-accent text-lg text-[#3a2630] text-left"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="mobile-nav-get-in-touch"
            onClick={() => go("#contact")}
            className="font-accent text-base px-5 py-3 rounded-full bg-[#b76e79] text-[#f7efe2] text-center"
          >
            Get in Touch
          </button>
        </div>
      )}
    </header>
  );
}
